<template>
  <div class="banners-container">
    <img src="/img/banners/banner-banrisul.jpg" alt="Banner Banrisul" class="banner"/>
    <img src="/img/banners/banner-finep.jpg" alt="Banner Finep" class="banner"/>
  </div>
</template>

<script>

export default {
  name: "BannerSection",
}
</script>

<style lang="css" scoped>
@media screen and (max-width: 900px) {
  .banner {
    width: 90% !important;
  }
}

.banners-container {
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 40px 0;
  gap: 20px;
}

.banner {
  width: 45%;
}
</style>